/* Baby Harmonie — animations au défilement, onglets, FAQ, barre d'achat collante */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = document.documentElement;
  if (!reduce && 'IntersectionObserver' in window) root.classList.add('bh-anim');

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    /* ---------- Apparition au défilement ---------- */
    var main = document.getElementById('MainContent');
    if (main) {
      var sections = main.querySelectorAll(':scope > .shopify-section, :scope > div > .shopify-section');
      sections.forEach(function (s, i) {
        if (i === 0) return;
        if (!s.querySelector('[data-bh-own-reveal]')) s.classList.add('bh-reveal');
      });
    }
    document.querySelectorAll('[data-bh-stagger]').forEach(function (group) {
      Array.prototype.forEach.call(group.children, function (child, i) {
        child.classList.add('bh-reveal');
        child.style.setProperty('--bh-delay', (i * 0.12).toFixed(2) + 's');
      });
    });

    var targets = document.querySelectorAll('.bh-reveal, .bh-step');
    if (root.classList.contains('bh-anim')) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('bh-in');
            io.unobserve(e.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
      targets.forEach(function (t) { io.observe(t); });
      setTimeout(function () { targets.forEach(function (t) { t.classList.add('bh-in'); }); }, 6000);
    } else {
      targets.forEach(function (t) { t.classList.add('bh-in'); });
    }

    /* ---------- Onglets ---------- */
    document.querySelectorAll('[data-bh-tabs]').forEach(function (wrap) {
      var btns = wrap.querySelectorAll('.bh-tab-btn');
      var panels = wrap.querySelectorAll('.bh-tab-panel');
      btns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          btns.forEach(function (b) { b.classList.remove('is-active'); b.setAttribute('aria-selected', 'false'); });
          panels.forEach(function (p) { p.classList.remove('is-active'); });
          btn.classList.add('is-active');
          btn.setAttribute('aria-selected', 'true');
          var panel = wrap.querySelector('[data-bh-panel="' + btn.dataset.tab + '"]');
          if (panel) panel.classList.add('is-active');
        });
      });
    });

    /* ---------- FAQ ---------- */
    document.querySelectorAll('.bh-faq-question').forEach(function (q) {
      q.addEventListener('click', function () {
        var item = q.closest('.bh-faq-item');
        var open = item.classList.toggle('is-open');
        q.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });

    /* ---------- Barre d'achat collante (fiche produit) ---------- */
    if (!document.body.classList.contains('template-product')) return;
    var form = document.querySelector('#MainContent form[action*="/cart/add"]');
    if (!form) return;
    var addBtn = form.querySelector('button[name="add"], [type="submit"]');
    if (!addBtn) return;

    var titleEl = document.querySelector('#MainContent .product-single__title, #MainContent h1');
    var priceEl = document.querySelector('#MainContent .product__price:not(.product__price--compare), #MainContent [data-product-price]');
    var imgEl = document.querySelector('#MainContent .product-image-main img, #MainContent .product__photos img');

    var bar = document.createElement('div');
    bar.className = 'bh-sticky';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML =
      '<div class="bh-sticky__in">' +
        (imgEl ? '<img class="bh-sticky__img" alt="" src="' + (imgEl.currentSrc || imgEl.src) + '">' : '') +
        '<div class="bh-sticky__info">' +
          '<div class="bh-sticky__title"></div>' +
          '<div class="bh-sticky__price"></div>' +
        '</div>' +
        '<button type="button" class="bh-btn bh-btn--terra" tabindex="-1">Ajouter au panier</button>' +
      '</div>';
    document.body.appendChild(bar);

    var tEl = bar.querySelector('.bh-sticky__title');
    var pEl = bar.querySelector('.bh-sticky__price');
    function sync() {
      if (titleEl) tEl.textContent = titleEl.textContent.trim();
      if (priceEl) pEl.textContent = priceEl.textContent.replace(/\s+/g, ' ').trim();
      var disabled = addBtn.disabled || addBtn.hasAttribute('disabled');
      bar.querySelector('button').disabled = disabled;
    }
    sync();
    form.addEventListener('change', function () { setTimeout(sync, 150); });

    bar.querySelector('button').addEventListener('click', function () {
      if (addBtn.disabled) return;
      addBtn.click();
    });

    var watch = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var past = !e.isIntersecting && e.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', past);
        bar.setAttribute('aria-hidden', past ? 'false' : 'true');
      });
    });
    watch.observe(addBtn);
  });
})();
